/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import PropTypes from 'prop-types';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import {
  tabsHeader,
  tabsContent,
  shadowEffectLeft,
  shadowEffectRight,
  tabsWrapper,
} from './index.styles';

class Tabs extends SafePureComponent {
  state = {
    activeTab: '',
    shouldRenderRightEffect: true,
    shouldRenderLeftEffect: false,
  };

  scrolleableElementRef = React.createRef();

  onChangeTabs = event => {
    this.setState({ activeTab: event.target.id });
    if (typeof this.props.onChangeProp === 'function') {
      this.props.onChangeProp(event);
    }
  };

  onScrollTabs = () => {
    const {
      offsetWidth,
      scrollWidth,
      scrollLeft,
    } = this.scrolleableElementRef.current;

    const shouldRenderRightEffect = !(scrollLeft >= scrollWidth - offsetWidth);
    const shouldRenderLeftEffect = !(scrollLeft <= 10);

    this.setState({ shouldRenderRightEffect, shouldRenderLeftEffect });
  };

  componentDidMount() {
    this.setState({ activeTab: this.props.firstItemActive });
    this.scrolleableElementRef.current.addEventListener(
      'scroll',
      this.onScrollTabs,
    );
    window.addEventListener('resize', this.onScrollTabs);
  }

  componentWillUnmount() {
    this.scrolleableElementRef.current.removeEventListener(
      'scroll',
      this.onScrollTabs,
    );
    window.removeEventListener('resize', this.onScrollTabs);
  }

  safeRender() {
    const {
      renderTabs,
      renderContent,
      showLeftEffect,
      classNameTabsHeader,
      classNameTabsContent,
    } = this.props;
    const {
      activeTab,
      shouldRenderRightEffect,
      shouldRenderLeftEffect,
    } = this.state;
    return (
      <section>
        <div css={tabsWrapper}>
          <ul
            ref={this.scrolleableElementRef}
            css={[tabsHeader, classNameTabsHeader]}
          >
            {renderTabs(activeTab, this.onChangeTabs)}
          </ul>
          {showLeftEffect && shouldRenderLeftEffect && (
            <span css={shadowEffectLeft} />
          )}
          {shouldRenderRightEffect && <span css={shadowEffectRight} />}
        </div>
        <div css={[tabsContent, classNameTabsContent]}>
          {renderContent(activeTab, this.onChangeTabs)}
        </div>
      </section>
    );
  }
}

Tabs.displayName = 'Tabs';

Tabs.propTypes = {
  firstItemActive: PropTypes.string,
  classNameTabsHeader: PropTypes.object,
  classNameTabsContent: PropTypes.object,
  renderTabs: PropTypes.func,
  renderContent: PropTypes.func,
  showLeftEffect: PropTypes.bool,
  onChangeProp: PropTypes.func,
};

export default Tabs;
